import { useState, useEffect } from 'react';
import { navLinks } from '@/mocks/homeData';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('section-1');

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);

      const sections = navLinks.map(l => l.target);
      for (let i = sections.length - 1; i >= 0; i--) {
        const el = document.getElementById(sections[i]);
        if (el && el.getBoundingClientRect().top <= 200) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (target: string) => {
    const el = document.getElementById(target);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    setIsMobileOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'glass-nav'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="flex items-center justify-between h-16 md:h-20">
          <button
            onClick={() => scrollTo('section-1')}
            className="flex items-center gap-2 group cursor-pointer"
          >
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-gold-500 to-gold-600 flex items-center justify-center breathing-glow transition-transform duration-300 group-hover:scale-110 group-hover:rotate-6">
              <i className="ri-brain-line text-white text-sm" />
            </div>
            <span className={`font-heading text-base md:text-lg font-bold tracking-tight transition-colors duration-300 ${
              isScrolled ? 'text-primary-700' : 'text-foreground-900'
            }`}>
              AI思政评课
            </span>
          </button>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <button
                key={link.target}
                onClick={() => scrollTo(link.target)}
                className={`relative px-3 lg:px-4 py-2 rounded-lg text-sm font-body whitespace-nowrap transition-all duration-300 cursor-pointer ${
                  activeSection === link.target
                    ? 'glass-gold border-gold-200/40 text-gold-700 font-medium scale-105'
                    : isScrolled
                      ? 'text-foreground-600 hover:text-gold-600 hover:bg-background-100/60'
                      : 'text-foreground-800 hover:text-gold-700 hover:bg-white/15'
                }`}
              >
                {link.label}
                {activeSection === link.target && (
                  <span className="absolute -bottom-0.5 left-1/2 -translate-x-1/2 w-5 h-0.5 rounded-full bg-gradient-to-r from-gold-300 to-gold-500 animate-scale-in" />
                )}
              </button>
            ))}
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg hover:bg-background-100/60 transition-colors cursor-pointer"
            onClick={() => setIsMobileOpen(!isMobileOpen)}
          >
            <i className={`ri-${isMobileOpen ? 'close' : 'menu'}-line text-xl ${isScrolled ? 'text-foreground-800' : 'text-foreground-900'}`} />
          </button>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden glass-nav">
          <div className="px-6 py-4 space-y-1">
            {navLinks.map((link) => (
              <button
                key={link.target}
                onClick={() => scrollTo(link.target)}
                className={`block w-full text-left px-4 py-3 rounded-lg text-sm font-body transition-colors ${
                  activeSection === link.target
                    ? 'glass-gold border-gold-200/40 text-gold-700 font-medium'
                    : 'text-foreground-600 hover:bg-background-100/60'
                }`}
              >
                {link.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}